module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Modificaciones\" ng-click=\"$ctrl.verModificaciones()\">\n  <i class=\"fa fa-medium\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/proyectos/bandeja/modificaciones/button.html
// module id = 641
// module chunks = 0